import { defineStore } from 'pinia'
import axios from '@/utils/axios'
import router from '@/router'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    tokenExpiresAt: parseInt(localStorage.getItem('tokenExpiresAt')) || null
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.token
  },
  
  actions: {
    async login(email, password) {
      try {
        const response = await axios.post('/auth/login', { email, password })
        this.token = response.data.access_token
        localStorage.setItem('token', this.token)
        
        // Calculate token expiration (24 hours from now)
        const expiresAt = Date.now() + (24 * 60 * 60 * 1000)
        this.tokenExpiresAt = expiresAt
        localStorage.setItem('tokenExpiresAt', expiresAt.toString())
        
        // Get user info
        await this.fetchUser()
        
        router.push({ name: 'Dashboard' })
      } catch (error) {
        throw error
      }
    },
    
    async register(email, password, full_name) {
      try {
        const response = await axios.post('/auth/register', { 
          email, 
          password,
          full_name,
          is_active: true,
          is_superuser: false
        })
        return response.data
      } catch (error) {
        throw error
      }
    },
    
    async fetchUser() {
      try {
        // Decode JWT token to get user info
        if (this.token) {
          const base64Url = this.token.split('.')[1]
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
          const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          }).join(''))
          
          const payload = JSON.parse(jsonPayload)
          this.user = { email: payload.sub }
          localStorage.setItem('user', JSON.stringify(this.user))
        }
      } catch (error) {
        console.error('Error decoding token:', error)
        this.user = { email: 'User' }
      }
    },
    
    logout() {
      this.token = null
      this.user = null
      this.tokenExpiresAt = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('tokenExpiresAt')
      router.push({ name: 'Login' })
    }
  }
})

